import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DriftStatusBesked } from 'src/app/api/models';
import { AlertService } from 'src/app/api/services';
import { AppConfigService } from 'src/app/config/app-config.service';
import { BomCookieService } from 'src/app/core/services/bom-cookie/bom-cookie.service';

@Injectable({
  providedIn: 'root',
})
export class OperatingStatusService {
  constructor(
    private alertService: AlertService,
    private appConfigService: AppConfigService,
    private cookieService: BomCookieService
  ) {}

  driftStatusBeskeder$: Observable<DriftStatusBesked[]>;

  private load$ = new BehaviorSubject<void>(undefined);
  private readonly driftStatusBeskederHiddenCookieName = 'driftStatusBeskederHidden';

  initialize() {
    const interval = this.appConfigService.getConfig().refreshOperatingStatusIntervalSeconds * 1000;
    this.driftStatusBeskeder$ = this.startPolling(interval);
  }

  hide(driftStatusBesked: DriftStatusBesked) {
    this.addToHidden(driftStatusBesked);
    this.load$.next();
  }

  private startPolling(interval: number): Observable<DriftStatusBesked[]> {
    return combineLatest([this.load$, timer(0, interval)]).pipe(
      switchMap(_ => this.alertService.getDriftStatus()),
      map(driftStatusBeskeder => {
        const hiddenSet = this.getHidden();
        return driftStatusBeskeder.filter(
          driftStatusBesked => !hiddenSet.has(driftStatusBesked.id)
        );
      })
    );
  }

  private addToHidden(driftStatusBesked: DriftStatusBesked) {
    const hidden = this.getHidden();
    hidden.add(driftStatusBesked.id);
    const expireInHours = this.appConfigService.getConfig().operatingStatusCookieHoursToLive || 12;
    this.cookieService.set(
      this.driftStatusBeskederHiddenCookieName,
      JSON.stringify(hidden),
      expireInHours / 24
    );
  }
  private getHidden(): Set<string> {
    const cookie = this.cookieService.get(this.driftStatusBeskederHiddenCookieName);
    if (!cookie) {
      return new Set<string>();
    }

    return this.parseJSON(cookie);
  }

  private parseJSON(value: string): Set<string> {
    try {
      const array: string[] = JSON.parse(value);
      return new Set<string>(array);
    } catch (e) {
      return new Set<string>();
    }
  }
}
